import axios from '@/api/axios';
import {
  ErrorResponse,
  LoginParams,
  LoginResponse,
  SuccessResponse,
  Token,
  User,
  UserDataResponse,
} from '@/types/api';
import apiConfig from '@/config/url-api';

import {
  UseMutateFunction,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import useAuthStore from '@/store/auth';

export const postLogin = async (params: LoginParams): Promise<Token> => {
  const response = await axios.post<LoginResponse>(apiConfig.auth.login, params);
  return response.data.data;
};

export const getUserData = async (): Promise<User> => {
  const response = await axios.get<UserDataResponse>(apiConfig.auth.me);
  return response.data.data;
};

export const useMutationLogin = () => {
  const loginMutation = useMutation({
    mutationFn: (data: LoginParams) => postLogin(data),
  } as UseMutationOptions<Token, unknown, LoginParams, unknown>);

  return loginMutation;
};

export type QueryLoginKey = ['login'];

export const useQueryUser = (): UseQueryResult<User, Error> => {
  const user = useQuery({
    queryKey: ['UserData'],
    queryFn: getUserData,
    enabled: false,
    retry: 2,
  });

  return user;
};
